import React, { lazy, Suspense } from 'react';
import { LoadingSpinner } from '@miroculus/miroculus-ui';
const DeviceDetails = lazy(() => import(
/* webpackChunkName: 'device-details' */
'./DeviceDetails'));
const loading = React.createElement(LoadingSpinner, { message: "Loading device details..." });
const DeviceDetailsLoader = () => (React.createElement(Suspense, { fallback: loading },
    React.createElement(DeviceDetails, null)));
export default DeviceDetailsLoader;
